import { render, staticRenderFns } from "./DialogCadastro.vue?vue&type=template&id=248b06f8"
import script from "./DialogCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogCadastro.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports